import { create } from "zustand";

export const DEFAULT_FILTERS = {
  projectIds: [],
  customerIds: [],
  datePreset: "last-30-days",
  dateFrom: "",
  dateTo: "",
  status: "all"
};

const useDashboardStore = create((set) => ({
  filters: { ...DEFAULT_FILTERS },
  isHydrated: false,
  setFilters: (partial) =>
    set((state) => ({
      filters: { ...state.filters, ...partial }
    })),
  resetFilters: () => set({ filters: { ...DEFAULT_FILTERS } }),
  setHydrated: (value) => set({ isHydrated: value })
}));

export default useDashboardStore;